<template>
  <v-card class="chart">
    <header class="chart-header"
            :class="{ 'chart-header--center': isTitleCenter }">
      <h2 class="chart-title">{{title}}</h2>

      <v-divider />
    </header>
    <div class="chart-content py-0 px-0"
         :class="{ 'widget-content--small': isContentSmall }">
      <slot></slot>
    </div>
  </v-card>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: 'Title here ...'
    },
    height: {
      type: String,
      default: '100%'
    },
    isTitleCenter: {
      type: Boolean,
      default: false
    },
    isContentSmall: {
      type: Boolean,
      default: false
    }
  }
}
</script>


<style lang="sass">
  @import '../../../assets/style/charts'

  .widget
    .absolute-center
      top: calc(50% + 25px)
</style>
